import React from 'react'
import CustomMenu from "components/CustomMenu/index";

const menus = [
  {
    title: '首页',
    icon: 'home',
    key: '/admin'
  },
  {
    title: '实盘交易',
    icon: 'desktop',
    key: '/admin/trade',
    subs: [
      {key: '/admin/trade/balance', title: '账户余额', icon: '',},
      {key: '/admin/trade/position', title: '策略持仓', icon: '',},
      {key: '/admin/trade/order', title: '订单查询', icon: '',},
      {key: '/admin/trade/transfer-inner', title: '内部转账', icon: '',},
      {key: '/admin/trade/transfer-sub', title: '子母转账', icon: '',},
    ]
  },
  {
    title: '策略分析',
    icon: 'desktop',
    key: '/admin/analyse',
    subs: [
      {key: '/admin/analyse/profit', title: '盈亏分析', icon: '',},
      {key: '/admin/analyse/strategy-symbol-pnl', title: '策略币种盈亏榜', icon: '',},
      {key: '/admin/analyse/slippage', title: '滑点分析', icon: '',},
      {key: '/admin/analyse/turnover', title: '换手率', icon: '',},
      {key: '/admin/analyse/fee', title: '费率分析', icon: '',},
      {key: '/admin/analyse/symbol-volume', title: '成交量分析', icon: '',},
    ]
  },
  {
    title: '数据管理',
    icon: 'desktop',
    key: '/admin/data',
    subs: [
      {key: '/admin/data/indicator', title: '指标监控', icon: '',},
      {key: '/admin/data/kline', title: 'K线查询', icon: '',},
      {key: '/admin/data/funding', title: '资金费率', icon: '',},
    ]
  },
  {
    title: '策略管理',
    icon: 'desktop',
    key: '/admin/strategy',
    subs: [
      {key: '/admin/strategy/list', title: '策略列表', icon: '',},
      {key: '/admin/strategy/select-coin', title: '回测选币', icon: '',},
      {key: '/admin/strategy/back-result', title: '资金曲线', icon: '',},
      {key: '/admin/strategy/traversal-result', title: '策略遍历', icon: '',},
      {key: '/admin/strategy/heatmap', title: '热力图', icon: '',},
      {key: '/admin/strategy/back-trade-cmp', title: '回测实盘对比', icon: '',},
    ]
  },
  {
    title: '因子分析',
    icon: 'desktop',
    key: '/admin/factor',
    subs: [
      {key: '/admin/factor/panel', title: '面板分析', icon: '',},
      {key: '/admin/factor/visual', title: '因子可视化', icon: '',},
    ]
  }
]


class SiderNav extends React.Component {
  render() {

    return (
      <div style={{height: '100vh',overflowY:'scroll'}}>
        <div style={styles.logo}></div>
        <CustomMenu menus={menus}/>
      </div>
    )
  }
}

const styles = {
  logo: {
    height: '10px',
    // background: 'rgba(255, 255, 255, .2)',
    // margin: '16px'
  }
}

export default SiderNav



// WEBPACK FOOTER //
// ./src/components/SiderNav/index.js